import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";

class Trimester extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            status_widget     : "inactive",
            current_key_time  : "",
            result_rows       : [],
            totals_widgets    : { reservations_ly_by_widget : 0, reservations_by_widget : 0 }
        }
        this.getDefaultValues = this.getDefaultValues.bind(this);
    }
    getDefaultValues(){
        return {
            status_widget: "inactive",
            current_key_time: "",
            result_rows: [],
            totals_widgets: { reservations_ly_by_widget: 0, reservations_by_widget: 0 }
        }
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    handleTimeFilter(filt, segments, key){
        let $self               = this;
        let status              = this.state.status_widget === "active" ? "inactive" : "active";
        let current_key_time    = "";
        let widgetSegment       = this.props.widgetSegment;
        this.props.activeFiltersMS(status)
        this.setState(function(prevState, props){
            if(prevState.current_key_time !== filt){
                $self.props.setSegments(segments, key, filt);
                current_key_time = filt;
            }else if(prevState.current_key_time === filt){
                current_key_time = "";
                $self.props.setSegments(null, key, filt);
            }
            return {
                current_key_time : current_key_time,
                status_widget : status
            }
        });
    }
    componentWillReceiveProps(props){}

    render(){    
        
        this.state.total_widgets    = this.props.total_widgets;
        let wdg                     = this.props.statics;  
        let count                   = Object.keys(wdg).length;

        if(count > 0){

            this.state.result_rows = Object.keys(wdg).map((filt, index) =>
                <div key={"list-trimester-"+index} className={"datagrid-item " + wdg[filt].state}>
                    <div>
                        <span className="title day">{ wdg[filt].string_value }</span> 
                        <span onClick={this.handleTimeFilter.bind(this, filt, wdg[filt].segments, wdg[filt].key_value) } 
                        className={"filter-row " + wdg[filt].state }>
                        </span>
                    </div>
                </div>
            )
        }
        return (
            <div className={"datagrid-widget by-trimester " +  this.props.filter_trimester_active + " " + this.props.hide_widget_trimester + " show-widget complete"}>
                <div className={"container-fluid "}>
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">TRIMESTRE</span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <span>{(this.props.key_trimester.split(" (")[0])}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                {this.state.result_rows}
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
};

export default Trimester;



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Review/Trimester.js